import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx, normalizeClass as _normalizeClass, createVNode as _createVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-7c561701"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "vab-tabs"
};
const _hoisted_2 = ["onContextmenu"];

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "vab-tabs-more-icon"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "box box-t"
}), /*#__PURE__*/_createElementVNode("i", {
  class: "box box-b"
})], -1
/* HOISTED */
));

const _hoisted_4 = [_hoisted_3];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_vab_fold = _resolveComponent("vab-fold");

  const _component_vab_icon = _resolveComponent("vab-icon");

  const _component_el_tab_pane = _resolveComponent("el-tab-pane");

  const _component_el_tabs = _resolveComponent("el-tabs");

  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");

  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");

  const _component_el_dropdown = _resolveComponent("el-dropdown");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [$props.layout === 'common' ? (_openBlock(), _createBlock(_component_vab_fold, {
    key: 0
  })) : _createCommentVNode("v-if", true), _createVNode(_component_el_tabs, {
    modelValue: $setup.tabActive,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.tabActive = $event),
    class: _normalizeClass(["vab-tabs-content", {
      ['vab-tabs-content-' + $setup.theme.tabsBarStyle]: true
    }]),
    type: "card",
    onTabClick: $setup.handleTabClick,
    onTabRemove: $setup.handleTabRemove
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.visitedRoutes, item => {
      return _openBlock(), _createBlock(_component_el_tab_pane, {
        key: item.path,
        closable: !$setup.isNoCLosable(item),
        name: item.path
      }, {
        label: _withCtx(() => [_createElementVNode("span", {
          style: {
            "display": "inline-block"
          },
          onContextmenu: _withModifiers($event => $setup.openMenu($event, item), ["prevent"])
        }, [$setup.theme.showTabsIcon ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [item.meta && item.meta.icon ? (_openBlock(), _createBlock(_component_vab_icon, {
          key: 0,
          icon: item.meta.icon,
          "is-custom-svg": item.meta.isCustomSvg
        }, null, 8
        /* PROPS */
        , ["icon", "is-custom-svg"])) : (_openBlock(), _createBlock(_component_vab_icon, {
          key: 1,
          icon: item.parentIcon
        }, null, 8
        /* PROPS */
        , ["icon"]))], 64
        /* STABLE_FRAGMENT */
        )) : _createCommentVNode("v-if", true), _createElementVNode("span", null, _toDisplayString($setup.translateTitle(item.meta.title)), 1
        /* TEXT */
        )], 40
        /* PROPS, HYDRATE_EVENTS */
        , _hoisted_2)]),
        _: 2
        /* DYNAMIC */

      }, 1032
      /* PROPS, DYNAMIC_SLOTS */
      , ["closable", "name"]);
    }), 128
    /* KEYED_FRAGMENT */
    ))]),
    _: 1
    /* STABLE */

  }, 8
  /* PROPS */
  , ["modelValue", "class"]), _createVNode(_component_el_dropdown, {
    class: "menvList",
    placement: "bottom-end",
    "popper-class": "vab-tabs-more-dropdown",
    onCommand: $setup.handleCommand,
    onVisibleChange: $setup.handleVisibleChange
  }, {
    dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, {
      class: "tabs-more"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
        command: "closeOthersTabs"
      }, {
        default: _withCtx(() => [_createVNode(_component_vab_icon, {
          icon: "close-line"
        }), _createElementVNode("span", null, _toDisplayString($setup.translateTitle('关闭其他')), 1
        /* TEXT */
        )]),
        _: 1
        /* STABLE */

      }), _createVNode(_component_el_dropdown_item, {
        command: "closeLeftTabs"
      }, {
        default: _withCtx(() => [_createVNode(_component_vab_icon, {
          icon: "arrow-left-line"
        }), _createElementVNode("span", null, _toDisplayString($setup.translateTitle('关闭左侧')), 1
        /* TEXT */
        )]),
        _: 1
        /* STABLE */

      }), _createVNode(_component_el_dropdown_item, {
        command: "closeRightTabs"
      }, {
        default: _withCtx(() => [_createVNode(_component_vab_icon, {
          icon: "arrow-right-line"
        }), _createElementVNode("span", null, _toDisplayString($setup.translateTitle('关闭右侧')), 1
        /* TEXT */
        )]),
        _: 1
        /* STABLE */

      }), _createVNode(_component_el_dropdown_item, {
        command: "closeAllTabs"
      }, {
        default: _withCtx(() => [_createVNode(_component_vab_icon, {
          icon: "close-line"
        }), _createElementVNode("span", null, _toDisplayString($setup.translateTitle('关闭全部')), 1
        /* TEXT */
        )]),
        _: 1
        /* STABLE */

      })]),
      _: 1
      /* STABLE */

    })]),
    default: _withCtx(() => [_createElementVNode("span", {
      class: _normalizeClass(["vab-tabs-more", {
        'vab-tabs-more-active': $setup.active
      }])
    }, _hoisted_4, 2
    /* CLASS */
    )]),
    _: 1
    /* STABLE */

  }), $setup.visible ? (_openBlock(), _createElementBlock("ul", {
    key: 1,
    class: "contextmenu el-dropdown-menu el-dropdown-menu--small",
    style: _normalizeStyle({
      left: $setup.left + 'px',
      top: $setup.top + 'px'
    })
  }, [_createElementVNode("li", {
    class: _normalizeClass(["el-dropdown-menu__item", {
      'is-disabled': $setup.visitedRoutes.length === 1
    }]),
    onClick: $setup.closeOthersTabs
  }, [_createVNode(_component_vab_icon, {
    icon: "close-line"
  }), _createElementVNode("span", null, _toDisplayString($setup.translateTitle('关闭其他')), 1
  /* TEXT */
  )], 2
  /* CLASS */
  ), _createElementVNode("li", {
    class: _normalizeClass(["el-dropdown-menu__item", {
      'is-disabled': !$setup.visitedRoutes.indexOf($setup.hoverRoute)
    }]),
    onClick: $setup.closeLeftTabs
  }, [_createVNode(_component_vab_icon, {
    icon: "arrow-left-line"
  }), _createElementVNode("span", null, _toDisplayString($setup.translateTitle('关闭左侧')), 1
  /* TEXT */
  )], 2
  /* CLASS */
  ), _createElementVNode("li", {
    class: _normalizeClass(["el-dropdown-menu__item", {
      'is-disabled': $setup.visitedRoutes.indexOf($setup.hoverRoute) === $setup.visitedRoutes.length - 1
    }]),
    onClick: $setup.closeRightTabs
  }, [_createVNode(_component_vab_icon, {
    icon: "arrow-right-line"
  }), _createElementVNode("span", null, _toDisplayString($setup.translateTitle('关闭右侧')), 1
  /* TEXT */
  )], 2
  /* CLASS */
  ), _createElementVNode("li", {
    class: "el-dropdown-menu__item",
    onClick: $setup.closeAllTabs
  }, [_createVNode(_component_vab_icon, {
    icon: "close-line"
  }), _createElementVNode("span", null, _toDisplayString($setup.translateTitle('关闭全部')), 1
  /* TEXT */
  )])], 4
  /* STYLE */
  )) : _createCommentVNode("v-if", true)]);
}